import GEO_META from "@khitmah/shared/src/Meta/geo.json";

export const getCountries = () => Object.keys(GEO_META);

export const getCities = (country) => GEO_META[country];
